import { Container } from "@mui/material";
import React, { FC, ReactNode } from "react";

type XsContProps = {
  children: ReactNode;
};

const XsCont: FC<XsContProps> = ({ children }: XsContProps) => {
  return <Container maxWidth="xs">{children}</Container>;
};

export default XsCont;
